import React from "react";
import { withRouter } from "react-router-dom";
import ReactGA from "react-ga";
import BasicUser from "./UserProfiles/basicUser";
import ColectivoUser from "./UserProfiles/colectivoUser";
import { api, logoutFES } from "../components/utils/JWTAuth";

class Perfil extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userInfo: null,
      userOrders: [],
      key: "personalData",
      personalDataNotComplete: false,
      profesionalDataNotComplete: false,
      msgCompleteProfilePersonal: null,
      msgCompleteProfileProfesional: null,
      msgCompleteProfileSettings: null,
      showLinkToPDF: false,
      numComitesPagoPDF: 0,
      userToColectivo: 0,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(key) {
    this.setState({ key });
  }

  // Check if personal data is complete
  isPersonalDataComplete = (userData) => {
    return (
      userData.name &&
      userData.lastname &&
      userData.nif &&
      userData.birthdate &&
      userData.country &&
      userData.gender &&
      userData.address_1 &&
      userData.postal_code &&
      userData.city &&
      userData.region &&
      userData.country_residence &&
      userData.phone
    );
  };

  // Check if professional data is complete
  isProfessionalDataComplete = (userData) => {
    return userData.org && userData.job && userData.education;
  };

  // Check if settings are complete
  isSettingsComplete = (userData) => {
    return userData.newsletter !== 2 && userData.type_status !== 2;
  };

  fetchUserData = async () => {
    try {
      const response = await api.get('/get_me.php');
      const userData = response.data;
      
      // Store user data in localStorage
      localStorage.setItem('me', JSON.stringify(userData));

      this.setState({ 
        userInfo: userData,
        personalDataNotComplete: !this.isPersonalDataComplete(userData),
        profesionalDataNotComplete: !this.isProfessionalDataComplete(userData)
      });
      
      // Set completeness messages
      this.setCompletenessMessages(userData);
      
    } catch (error) {
      // 401 automatically handled by interceptor
      if (error.response?.status !== 401) {
        console.error('Profile data error:', error);
      }
      logoutFES();
    }
  };

  // Set all completeness messages (replaces old setMessageWarning)
  setCompletenessMessages = (userData) => {
    this.setState({
      msgCompleteProfilePersonal: this.isPersonalDataComplete(userData) 
        ? null 
        : "Los campos marcados con un asterisco (*) serán obligatorios",
      msgCompleteProfileProfesional: this.isProfessionalDataComplete(userData)
        ? null
        : "Los campos marcados con un asterisco (*) serán obligatorios",
      msgCompleteProfileSettings: this.isSettingsComplete(userData)
        ? null
        : "Los campos marcados con un asterisco (*) serán obligatorios"
    });
  };

  fetchUserOrders = async () => {
    if (!this.state.userInfo?.id) return;
    
    try {
      const response = await api.post('/user/orders', { 
        id_user: this.state.userInfo.id 
      });
      this.setState({ userOrders: response.data.records || [] });
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };

  componentDidMount() {
    // First check localStorage for cached user data
    const cachedUser = localStorage.getItem('me');
    if (cachedUser) {
      try {
        const userData = JSON.parse(cachedUser);
        this.setState({ 
          userInfo: userData,
          personalDataNotComplete: !this.isPersonalDataComplete(userData),
          profesionalDataNotComplete: !this.isProfessionalDataComplete(userData)
        });
        this.setCompletenessMessages(userData);
      } catch (e) {
        logoutFES();
      }
    }

    // Then fetch fresh data
    this.fetchUserData();
    
    // Handle any state passed via router
    const { state } = this.props.history.location;
    if (state) {
      this.setState({
        key: state.key,
        ...(state.userToColectivo && { userToColectivo: state.userToColectivo })
      });
    }
    
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentDidUpdate(prevProps, prevState) {
    // Fetch orders when user data changes
    if (this.state.userInfo?.id !== prevState.userInfo?.id) {
      this.fetchUserOrders();
    }
  }

  renderUserTemplate = () => {
    const { userInfo, userToColectivo } = this.state;
    
    if (!userInfo) return null;

    const colectivoUserTypes = [4, 5, 6, 7, 10, 12, 14];
    const isColectivoUser = colectivoUserTypes.includes(+userInfo.id_type) || userToColectivo !== 0;

    return isColectivoUser ? (
      <ColectivoUser 
        toColectivo={userToColectivo}
        userInfo={userInfo}
        messages={{
          personal: this.state.msgCompleteProfilePersonal,
          professional: this.state.msgCompleteProfileProfesional,
          settings: this.state.msgCompleteProfileSettings
        }}
      />
    ) : (
      <BasicUser 
        userInfo={userInfo}
        messages={{
          personal: this.state.msgCompleteProfilePersonal,
          professional: this.state.msgCompleteProfileProfesional,
          settings: this.state.msgCompleteProfileSettings
        }}
      />
    );
  };

  render() {
    return (
      <div>
        {this.renderUserTemplate()}
      </div>
    );
  }
}

export default withRouter(Perfil);